const ForwardIconforGrid10 = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="ForwardIconforGrid10Id"
        className="ForwardIconforGrid10"
        style={{
          width: "48px",
          height: "48px",
          background: "white",
          borderRadius: "50rem",
          padding: "0.6rem",
          marginTop:"8rem"
        }}
        fill="#030202"
        viewBox="0 0 256 256"
      >
        <rect width="256" height="256" fill="none"></rect>
        <line
          x1="40"
          y1="128"
          x2="216"
          y2="128"
          fill="none"
          stroke="#030202"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8"
        ></line>
        <polyline
          points="144 56 216 128 144 200"
          fill="none"
          stroke="#030202"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8"
        ></polyline>
      </svg>
    </>
  );
};
export default ForwardIconforGrid10;
